import React from "react";

const Issues = ({ title, brand , model , price, purchaseYear }) => {
  return (
    <div
      className={`rounded-[12px] bg-[#FFFFFF] self-center lg:self-auto flex flex-row justify-start cursor-pointer border-[#D0D5DD] border-[1px] py-4`}
    >
      <div className="flex flex-row gap-[15px]">
        <div className="flex flex-col ml-5">
          <div className="font-[700] text-[16px] leading-[24px] text-[#344054]">
            {title}
          </div>
          <div className="mt-2">
            <div className="text-[#475467] text-[12px] leading-[18px] font-[400]">
              <strong>Brand:</strong> {brand}
            </div>
            <div className="text-[#475467] text-[12px] leading-[18px] font-[400]">
              <strong>Series:</strong> {model}
            </div>
            <div className="text-[#475467] text-[12px] leading-[18px] font-[400]">
              <strong>Device Value:</strong> {price}
            </div>
            <div className="text-[#475467] text-[12px] leading-[18px] font-[400]">
              <strong>Purchase Duration:</strong> {purchaseYear}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Issues;
